<template>
  <v-main style="margin: 10px">
    <v-data-table :headers="headers" :items="postList" :items-per-page="15" :search="keyword">
      <template v-slot:top>

        <v-row no-gutters style="padding: 20px 10px 0px" v-if="$store.state.principal.role == 'super_user'">
          <v-col>

            <v-row align="center">
              <v-col class="text-right" cols="6">
                Everyone can post?
              </v-col>

              <v-col cols="6">
                <v-row align="center" no-gutters>
                  <v-switch
                    v-model="isCanPost.canPost"
                    color="blue"
                    hide-details
                    inset
                    class="ma-0 pa-0"
                    @change="changePostAbility"
                  ></v-switch>
                  <span class="ml-2">{{ isCanPost.canPost ? 'Yes' : 'No' }}</span>
                </v-row>
              </v-col>
            </v-row>

          </v-col>

        </v-row>

        <v-row no-gutters style="padding: 20px 10px 0px">
          <v-col cols="12" sm="8">
            <div class="d-flex px-2">
              <h2>Duo Share</h2>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div class="d-flex px-2">
              <v-text-field v-model="keyword" append-icon="mdi-magnify" label="Search" hide-details
                style="margin-right: 10px"></v-text-field>
              <v-btn small fab dark color="secondary" title="Add" @click="addDialog = true" :disabled="!($store.state.principal.role == 'super_user' || isCanPost)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.content="{ item }">{{ $root.ellipsify(item.title, 30) }}</template>
      <template v-slot:item.content="{ item }">{{ $root.ellipsify(item.content, 30) }}</template>
      <template v-slot:item.created="{ item }">{{ JSON.stringify(item.created.date) }}</template>

      <template v-slot:item.action="{ item }">
        <div class="d-flex justify-end pr-4">
          
          <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
              <v-icon size="18" class="mr-2" v-on="{ ...tooltip }" @click="editPost(item)
                  ">mdi-comment-eye</v-icon>
              </template>
              <span>Show comments</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon size="18" class="mr-2" v-on="{ ...tooltip }" @click="showDialogEditAgencyGroups(item)
                  ">mdi-pencil</v-icon>
            </template>
            <span>Agency Groups</span>
          </v-tooltip>

          <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
              <v-icon size="18" class="ml-2 icon-tm-delete" v-on="{ ...tooltip }" @click="showDeletePost(item)
                  "></v-icon>
              </template>
              <span>Delete</span>
          </v-tooltip>

        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogEditAgencyGroups" persistent max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Agency Groups</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" style="padding: 0 40px" autocomplete="off">

            Publish To : <span v-if="agencyGroupIdList[0] == -1">N/A</span>

            <div v-if="agencyGroupIdList[0] != -1">
              <v-checkbox
                dense
                hide-details
                :value="0"
                label="All"
                :input-value="isAllSelected"
                @change="toggleAll"
              ></v-checkbox>

              <v-checkbox
                v-for="group in agencyGroupList"
                :key="group.id"
                dense
                hide-details
                :label="group.name"
                :value="group.id"
                v-model="agencyGroupIdList"
              ></v-checkbox>
            </div>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialogEditAgencyGroups">Cancel</v-btn>
          <v-btn v-if="agencyGroupIdList[0] != -1" @click="editAgencyGroups" color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addDialog" persistent max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">{{entity.id != null ? 'Edit' : 'Add'}} Post</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" style="padding: 0 40px" autocomplete="off">
            <v-text-field
              v-model="entity.title"
              label="Title*"
            ></v-text-field>
            <p class="mb-2">Content</p>
            <v-text-editor v-if="addDialog" label="Content" v-model="entity.content" :api-key="$tinyMceKey" :init="selectedInitEditor()"></v-text-editor>
            <p style="text-align: right; font-size: 12px; font-style: italic;">
            *) To resize an image, use the little blue squares on the corners of the image.
            </p>
            Publish To :

            <v-checkbox
              dense
              hide-details
              :value="0"
              label="All"
              :input-value="isAllSelected"
              @change="toggleAll"
            ></v-checkbox>

            <v-checkbox
              v-for="group in agencyGroupList"
              :key="group.id"
              dense
              hide-details
              :label="group.name"
              :value="group.id"
              v-model="agencyGroupIdList"
            ></v-checkbox>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeAddDialog">Cancel</v-btn>
          <v-btn @click="addPost" color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeletePost" max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Delete Post</span>
            </v-card-title>
            <v-card-text>Are you sure you want to delete '{{ entity.title }}' ?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialogDeletePost = false; entity = {}">Cancel</v-btn>
                <v-btn @click="deletePost" color="accent">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

   

  </v-main>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
  components: {
    "v-text-editor": Editor,
  },
  data: function () {
    return {
      snackbar: false,
      agencyGroupId: 0,
      keyword: "",
      headers: [
        { text: "Created", value: "createdDate" },
        { text: "Creator", value: "creatorName" },
        { text: "Title", value: "title" },
        { text: "", value: "action", sortable: false },
      ],
      postList: [],
      agent: { map: {} },
      entity: {
        map: {},
        title: "",
				content: "" 
      },
      tagList: [],
      confirmationDialog: {
        show: false,
        item: {},
        title: '',
        content: ''
      },
      dialogImpersonate: {
        show: false,
        item: {},
      },
      state: "",
      stateFilter: [''],
      addDialog: false,
      initEditor: {
					height: 150,
					width: '100%',
					selector: '',
					menubar: false,
					plugins: ["code", "paste", "table", "lists", "link", "textcolor" ],
					paste_as_text: true,
					fontsize_formats: "8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px",
					font_formats: "Arial=arial,helvetica,sans-serif; \
                                    Courier New=courier new,courier,monospace; \
                                    Georgia=georgia,palatino; \
                                    Tahoma=tahoma,arial,helvetica,sans-serif; \
                                    Times New Roman=times new roman,times; \
                                    Verdana=verdana,geneva;",
                    toolbar:
							"code undo redo | fontsizeselect | fontselect | bold italic underline forecolor backcolor | table | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | link | removeformat | pastetext | help"
			},
      dialogDeletePost: false,
      agencyGroupList: [],
      agencyGroupIdList: [],
      dialogEditPost: false,
      dialogEditAgencyGroups: false,
      isCanPost: {},
    };
  },
  mounted: function () {
    this.getPostAcess();
    this.getList();
    this.getAgencyGroupList();
  },
  computed: {
    
    // Check if "All" should be selected
    isAllSelected() {
      return (
        this.agencyGroupIdList.length === this.agencyGroupList.length ||
        this.agencyGroupIdList.includes(0)
      );
    },
  },
  watch: {
    agencyGroupIdList(newVal) {
      // If "All" is selected manually
      if (newVal.includes(0)) {
        this.agencyGroupIdList = this.agencyGroupList.map((g) => g.id);
      }
    },
  },
  methods: {
    getPostAcess() {
			axios
        .get("/system/globalsetting/get")
        .then((response) => {
          this.isCanPost = response.data;
        });
		},
    changePostAbility() {
      axios
      .post("/api/globalsetting/edit", { setting: this.isCanPost })
      .then(() => {});
    },
    editAgencyGroups() {

      this.entity.agencyGroupIdList = this.agencyGroupIdList.length == this.agencyGroupList.length ? [0] : this.agencyGroupIdList;

      axios
      .post("/system/post/add", { entity: this.entity })
      .then(() => {
        this.dialogEditAgencyGroups = false;
        this.agencyGroupIdList = [];
        this.entity = {};
        this.getList();
      });

    },
    closeDialogEditAgencyGroups() {
       this.dialogEditAgencyGroups = false;
       this.agencyGroupIdList = [];
       this.entity = {};
    },
    showDialogEditAgencyGroups(item) {
      this.entity = item;
      this.agencyGroupIdList = item.agencyGroupIdList;
      this.dialogEditAgencyGroups = true;
    },
    showDialogEditPost() {
      this.dialogEditPost = true;
    },
    toggleAll(value) {
      if (value) {
        this.agencyGroupIdList = this.agencyGroupList.map((g) => g.id);
      } else {
        this.agencyGroupIdList = [];
      }
    },
    getAgencyGroupList() {
      axios
        .get("/system/agency/group/list")
        .then((response) => {
          this.agencyGroupList = response.data;
        })
        .catch(() => { });
    },
    showDeletePost(item) {
      this.entity = item;
			this.dialogDeletePost = true;
		},
    deletePost() {
			axios
				.post("/system/post/delete", { id: this.entity.id })
				.then(() => {
					this.dialogDeletePost = false;
					this.getList();
          this.entity = {}
				})
				.catch(() => {});
		},
    editPost(item) {
      this.$router.push({path: "/administration/post/"+item.id}); 
    },
    addPost() {

      this.entity.agencyGroupIdList = this.agencyGroupIdList.length == this.agencyGroupList.length ? [0] : this.agencyGroupIdList;

      axios
      .post("/system/post/add", { entity: this.entity })
      .then(() => {
        this.addDialog = false;
        this.entity.id = null;
        this.entity.title = "";
        this.entity.content = "";
        this.getList();
      });
    },
    selectedInitEditor() {
      return this.$root.copyWith({ 
        height: 300,
        toolbar: 'undo redo | fontsizeselect fontselect | bold italic underline | forecolor backcolor removeformat | table | alignleft aligncenter alignright alignjustify | bullist numlist | link image media pastetext',
        plugins: 'image media link table lists charmap paste',
        file_picker_types: 'image',
        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype === 'image') {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/jpeg, image/jpg, image/png, image/gif, image/bmp')

            input.onchange = function () {
              const file = this.files[0]
              const reader = new FileReader()

              reader.onload = function () {
                const base64 = reader.result
                callback(base64, { title: file.name })
              }

              reader.readAsDataURL(file)
            }

            input.click()
          }
        },
      }, 
        this.initEditor);
		},
    getList() {
      axios
        .get("/system/post/list")
        .then((response) => {
          this.postList = response.data;
        })
        .catch(() => { });
    },
    closeAddDialog() {
      this.entity.id = null;
      this.entity.title = "";
      this.entity.content = "";
      this.addDialog = false;
    },
  },
};
</script>